module.exports = __webpack_public_path__ + "img/water-treatment-plant.a270b2c3.jpg";